import {Button, Col, Flex, Form, Input, Modal, Row, Select, Space, Switch, Typography} from "antd";
import {ArrowCounterClockwiseIcon, CaretDownIcon} from "@phosphor-icons/react";
import React, {useContext, useEffect, useState} from "react";
import {ThemeContext} from "../../../../contexts/ThemeContext";
import {ThemeColorContext} from "../../../../contexts/ThemeColorContext";
import {FOOT, INCH, METER, UnitContext} from "../../../../contexts/UnitContext";
import {useCurrentUser} from "../../../../contexts/UserContext";
import {ColorPicker} from "../../../index";
import ProfileAvatar from "./ProfilePhoto";
import { LengthUnit } from "../../../../@types/types";

type UserSettingsProps = {
    isUserSettingsModalOpen: boolean,
    setIsUserSettingsModalOpen: (open: boolean) => void
}

const UserSettings = (props: UserSettingsProps) => {
    const {isUserSettingsModalOpen, setIsUserSettingsModalOpen} = props;

    const {user} = useCurrentUser();
    const {Title} = Typography;
    const [form] = Form.useForm();


    const {theme, toggleTheme} = useContext(ThemeContext);
    const {primary, setPrimary, secondary, setSecondary} = useContext(ThemeColorContext);
    const [resetP, setResetP] = useState(true);
    const {unit, roofUnit, treeUnit, setUnit, setRoofUnit, setObstructionUnit, setTreeUnit} = useContext(UnitContext);


    const roofUnitChangeHandler = (e: any) => {
        const foundOption = options.find(obj => e === obj.label);
        if (foundOption && setRoofUnit && setObstructionUnit) { //null checks
            const value = foundOption.value;
            setRoofUnit(value as LengthUnit);
            setObstructionUnit(value as LengthUnit);
        }
    };

    const treeUnitChangeHandler = (e: any) => {
        const foundOption = options.find(obj => e === obj.label);
        if (foundOption && setTreeUnit) { //null checks
            const value = foundOption.value;
            setTreeUnit(value as LengthUnit);
        }
    };

    const unitChangeHandler = (e: any) => {
        const foundOption = options.find(obj => e === obj.label);
        if (foundOption && setUnit) { //null checks
            const value = foundOption.value;
            setUnit(value as LengthUnit);
        }
    };

    const resetPrimary = () => {
        setPrimary("#538abc");
    }

    useEffect(() => {
        if (primary === "#538abc") {
            setResetP(false);
        } else {
            setResetP(true);
        }

    }, [primary, secondary]);

    const options = [
        {value: METER, label: 'm'},
        {value: FOOT, label: 'ft'},
        {value: INCH, label: 'in'}
    ];

    const changePrimaryColor = (color: string) => {
        setPrimary(color);
    }


    return (
        <Modal
            open={isUserSettingsModalOpen}
            onOk={() => setIsUserSettingsModalOpen(false)}
            onCancel={() => setIsUserSettingsModalOpen(false)}
            centered
            footer={[]}
        >
            <Row gutter={[30, 30]}>
                <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Flex
                        align='center'
                        justify='space-between'
                    >
                        <Title level={4} style={{marginBottom: 30}}>User Profile</Title>
                        <ProfileAvatar/>

                    </Flex>


                    <Form
                        form={form}
                        name='profile'
                        layout='vertical'
                        size='large'
                    >
                        <Form.Item label='Employee ID' name='employeeId'>
                            <Input
                                type='text'
                                placeholder={user?.user_Id}
                                disabled
                            />
                        </Form.Item>
                        <Form.Item label='Name' name='name'>
                            <Input
                                type='text'
                                placeholder={user?.user_name}
                                disabled
                            />
                        </Form.Item>
                        <Form.Item label='User Role' name='userRole'>
                            <Input
                                type='text'
                                placeholder={user?.application_role_name}
                                disabled
                            />
                        </Form.Item>
                        <Form.Item label='Email Address' name='email' style={{margin: 0}}>
                            <Input
                                type='text'
                                placeholder={user?.email}
                                disabled
                            />
                        </Form.Item>
                    </Form>
                </Col>
                <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Title level={4} style={{marginBottom: 30}}>Settings</Title>
                    <Space direction='vertical' size='large'>
                        <Flex align='center' justify='space-between'>
                            <div>
                                <h4 className='form-group form-label'>Dark Mode</h4>
                                <span className='settings__meta form-group form-label'>Toggle the Dark Theme.</span>
                            </div>
                            <Switch
                                checked={theme === 'dark'}
                                onClick={(checked: boolean) => toggleTheme(checked ? 'dark' : 'light')}
                            />
                        </Flex>
                        <Flex align='center' justify='space-between'>
                            <div>
                                <h4 className='form-group form-label'>Primary Color</h4>
                                <span
                                    className='settings__meta form-group form-label'>Change your system primary color.</span>
                            </div>
                            <Space>

                                <ColorPicker
                                    changeHandler={changePrimaryColor}
                                    currentColor={primary}
                                />

                                {resetP && (
                                    <Button
                                        type='default'
                                        size='middle'
                                        icon={<ArrowCounterClockwiseIcon size={24}/>}
                                        onClick={resetPrimary}
                                    />
                                )}
                            </Space>
                        </Flex>

                        <Flex align='center' justify='space-between'>
                            <div>
                                <h4 className='form-group form-label'>Unit of Measurement</h4>
                            </div>
                            <div>
                                <span className='settings__meta form-group form-label'>Roof</span>
                                <Select
                                    placeholder='Select Unit'
                                    options={options}
                                    defaultValue={roofUnit}
                                    onChange={roofUnitChangeHandler}
                                    size='large'
                                    suffixIcon={<CaretDownIcon size={18}/>}
                                    style={{width: 75}}
                                    loading
                                />
                            </div>
                            <div>
                                <span className='settings__meta form-group form-label'>Tree</span>
                                <Select
                                    placeholder='Select Unit'
                                    options={options}
                                    defaultValue={treeUnit}
                                    onChange={treeUnitChangeHandler}
                                    size='large'
                                    suffixIcon={<CaretDownIcon size={18}/>}
                                    style={{width: 75}}
                                    loading
                                />
                            </div>
                            <div>
                                <span className='settings__meta form-group form-label'>Other</span>
                                <Select
                                    placeholder='Select Unit'
                                    options={options}
                                    defaultValue={unit}
                                    onChange={unitChangeHandler}
                                    size='large'
                                    suffixIcon={<CaretDownIcon size={18}/>}
                                    style={{width: 75}}
                                    loading
                                />
                            </div>
                        </Flex>
                    </Space>
                </Col>
            </Row>
        </Modal>
    )
}

export default UserSettings;